// extracted by mini-css-extract-plugin
export default {"error404":"Error404_error404__Korgd","wrapper":"Error404_wrapper__YDkP3"};